// extracted by mini-css-extract-plugin
module.exports = {"chatBody":"frontend-components-lesson1-common-styles-playground-chatBody__chatBody--PEm4G"};